import { render, staticRenderFns } from "./MFormPrinterModelList.vue?vue&type=template&id=23b83516&scoped=true"
import script from "./MFormPrinterModelList.vue?vue&type=script&lang=js"
export * from "./MFormPrinterModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b83516",
  null
  
)

export default component.exports